import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';
 
class EmailContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            
            loading : 1,
            company:'',
            firstname:'',
            lastname:'',
            jobtitle:'',
            mobile:'',
            email:'',
            company:'',
            logo:'',
            address:'',
            color:'#000000',
            website:'',
            telephone:'',
            fax:''

        }
        

    }

    componentDidMount()
    {  
         
         this.setState({loading:0});   
         console.log(this.props.ids)   
        
    }

      handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };


      handleChangeCompany = (event) => {

        const companies = JSON.parse(localStorage.getItem("companiesid"));
        const company = event.target.value;

        console.log(companies);
        console.log(company);
        
        this.setState({ companyid: companies[company].id });
        this.setState({ company: companies[company].title });
        this.setState({ logo: companies[company].logo });
        this.setState({ website: companies[company].website });
        this.setState({ address: companies[company].address });
        this.setState({ color: companies[company].color });
        this.setState({ telephone: companies[company].telephone });
        this.setState({ fax: companies[company].fax });
      };



    render()
    { 

          const companies = JSON.parse(localStorage.getItem("companies"));
       
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
          
    return (
      <div className="email-block" style={{background:'#fff', marginTop:'20px'}}> 
    <div className="form" style={{ clear: 'both', width: '100%' }}>
      
      <label style={{ width: '100%' }}>
        Select your Company
        <select
            name="company"
            id="company"
            value={this.state.companyid || ""}
            onChange={this.handleChangeCompany}
            >
            <option value="" disabled>
                Select A Company
            </option>

            {companies.map((item) => (
                <option key={item.id} value={item.id}>
                {item.title}
                </option>
            ))}
            </select>
      </label>
 
        <input
          type="text"
          name="firstname"
          id="firstname"
          value={this.state.firstname}
          placeholder="First Name"
          required
          autoComplete="name"
          onChange={this.handleChange}
        />
      
        <input
          type="text"
          name="lastname"
          id="lastname"
          value={this.state.lastname}
          placeholder="Last Name"
          required
          autoComplete="family-name"
          onChange={this.handleChange}
        />
       
        <input
          type="text"
          name="jobtitle"
          id="jobtitle"
          value={this.state.jobtitle}
          placeholder="Job Title"
          required
          autoComplete="organization-title"
          onChange={this.handleChange}
        />
       
        <input
          type="tel"
          name="mobile"
          id="mobile"
          value={this.state.mobile}
          placeholder="Mobile Number"
          required
          autoComplete="tel"
          onChange={this.handleChange}
        />
       

      
        <input
          type="email"
          name="email"
          id="email"
          value={this.state.email}
          placeholder="Full Email Address"
          required
          autoComplete="email"
          onChange={this.handleChange}
        />
     
    </div>

    <div>
        <br />
        <br />
      <span style={{ color: '#f00' }}>
        PLEASE COPY FROM THE BAR THE FURTHEST SPACE AT THE BOTTOM OF THE PAGE
      </span>

      <hr />
      <div style={{height:'50px'}}></div>
 
      {/* === SIGNATURE TABLE === */}

      <table
        style={{
          color: '#3D4543',
          fontFamily: 'helvetica',
          width: '520px',
          fontSize: '13px',
          padding: '0',
          margin: '0',
          borderCollapse:'0'
        }}
      >
        <tbody>
          <tr id="name">
            <td colSpan={2}>
              <b>
                <span
                  className="firstname" 
                >
                  {this.state.firstname}
                </span>
                &nbsp;
                <span
                  className="lastname"
                  
                >
                  {this.state.lastname}
                </span>
              </b>
            </td>
          </tr>

          <tr>
            <td colSpan={2}>
              <span className="jobtitle">{this.state.jobtitle}</span>
            </td>
          </tr>

          <tr style={{ height: '10px' }}>
            <td>&nbsp;</td>
          </tr>

          <tr>
            <td style={{ verticalAlign: 'top', width: '95px' }}>
              <img
                src={this.state.logo}
                width="75"
                style={{ paddingRight: '20px' }}
                alt="Logo"
              />
            </td>

            <td>
              <div
                className="companyname"
                style={{ color: this.state.color }}
              >
                <b>{this.state.company}</b>
              </div>

              <br />

              <table
                style={{
                  width: '100%',
                  fontSize: '13px',
                  lineHeight: '12px'
                }}
              >
                <tbody>
                  <tr>
                    <td style={{ width: '32px' }}><b>M</b></td>
                    <td>
                      <a
                        href={`tel:${this.state.mobile}`}
                        style={{ textDecoration: 'none', color: '#3D4543' }}
                      >
                        {this.state.mobile}
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td><b>T</b></td>
                    <td>
                      <a
                        href={this.state.telephone}
                        style={{ textDecoration: 'none', color: '#3D4543' }}
                      >
                        {this.state.telephone}
                      </a>
                    </td>
                  </tr>

                  <tr>
                    <td><b>E</b></td>
                    <td>
                      <a
                        href={`mailto:${this.state.email}`}
                        style={{ textDecoration: 'none', color: '#3D4543' }}
                      >
                        {this.state.email}
                      </a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td colSpan={2} style={{ height: '16px' }} />
          </tr>

          <tr>
            <td colSpan={2}>
              <span className="address1" dangerouslySetInnerHTML={{ __html: this.state.address}} />

              <div style={{ height: '16px' }} />

              <div style={{ fontWeight: 700 }}>
                <a
                  href={this.state.website}
                  style={{ textDecoration: 'none', color: this.state.color }}
                >
                  {this.state.website}
                </a>
                <br /> <br />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
      <br />
      <p style={{fontSize:'11px'}}>
  <b>CONFIDENTIALITY NOTICE:</b> The contents of this email message and any attachments are intended solely for the addressee(s) and may contain confidential and/or privileged information and may be legally protected from disclosure. If you are not the intended recipient of this message or their agent, or if this message has been addressed to you in error, please immediately alert the sender by reply email and then delete this message and any attachments. If you are not the intended recipient, you are hereby notified that any use, dissemination, copying, or storage of this message or its attachments is strictly prohibited.
</p>
    </div>
  </div>


    );
}

}

export default EmailContent;